// import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';
import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

	/** @ngInject */
	constructor(
		$state
	) {
		this.$state = $state;
	}

	$onInit() {
		if(this.isNote) {
			this.accountName=this.sharedAccount.noteName;
		} else {
			this.accountName=this.sharedAccount.publicService.serviceName+' - '+ this.sharedAccount.username;
		}
		this.defaultBackStateName=Object.keys(this.$state.$current.includes)[3];
        
	}

	
	
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-inner-menu/shared-inner-menu.controller.js